// vollmachtAusAuswahl.ts — „Hochladen" einer Vollmacht über die
// KMVS-Dokumentauswahl (T-42), an EINER Stelle für alle Wege der Akte:
// Aktenkopf (Kundenerstinformation, „weitere Vollmachten") und Abschnitt
// „Vollmachten".
//
// Ein vorhandenes KMVS-Dokument wird nur verknüpft (kein zweiter Upload, die
// Kategorie bleibt); eine Datei vom Rechner wird wie bisher unter
// „Vollmachten/<Ordner>" abgelegt und dann verknüpft.

import { documentService } from "../../services/documentService";
import { vollmachtService } from "../../services/vollmachtService";
import type { DokumentAuswahlErgebnis } from "../documents/auswahl/DokumentAuswahl";
import { vollmachtAblageOrdner, type VollmachtDto } from "./vollmachtTypes";

/** Ist in der Auswahl überhaupt etwas, das verknüpft werden kann? */
export const auswahlHatInhalt = (auswahl: DokumentAuswahlErgebnis): boolean =>
  auswahl.dokumente.length > 0 || auswahl.dateien.length > 0;

/**
 * Verknüpft die gewählte Datei bzw. das gewählte Dokument mit der Vollmacht.
 * `vollmacht` liefert die (ggf. erst anzulegende) Vollmacht — erst NACH der
 * Auswahl, damit „Abbrechen" nichts anlegt.
 */
export async function vollmachtAusAuswahlVerknuepfen(args: {
  contactId: number;
  art: string;
  auswahl: DokumentAuswahlErgebnis;
  vollmacht: () => Promise<VollmachtDto>;
}): Promise<void> {
  const { contactId, art, auswahl } = args;
  const vorhanden = auswahl.dokumente[0];
  const datei = auswahl.dateien[0];
  if (!vorhanden && !datei) return;
  const v = await args.vollmacht();
  const docId =
    vorhanden?.id ??
    (
      await documentService.upload({
        file: datei!,
        contactId,
        category: "Vollmacht",
        relativePath: vollmachtAblageOrdner(art),
        tags: ["vollmacht", art],
      })
    ).id;
  await vollmachtService.verknuepfen(contactId, v.id, docId);
}
